import axios from "axios";
import { api_URL } from "../constantes/BaseURL";


const instance = axios.create({
    baseURL: `${api_URL}`,
});

// instance.defaults.headers.common['perim'] = `${user_connect.prenom} ${user_connect.nom}`;

export default instance;